import { useState, useEffect } from 'react';
import { builder } from '@builder.io/react';
import { getAllBuilderData } from '../api/builderContent';

export function useDynamicNavigation() {
  const [navigationLinks, setNavigationLinks] = useState(null);

  useEffect(() => {
    if (builder.editingMode$.value || builder.preview) {
      const fetchNavigation = async () => {
        try {
          const links = await getAllBuilderData('navigation-links');
          setNavigationLinks(links);
        } catch (error) {
          console.error('Error fetching navigation:', error);
        }
      };

      fetchNavigation();
    }
  }, []);

  return navigationLinks;
}